import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { CheckIcon, UserIcon, LockClosedIcon } from "@heroicons/react/outline";
import { Link, Redirect, Route, Switch, withRouter } from "react-router-dom";
import Logo from "../logoai.png";
import { observable, makeObservable } from "mobx";
import { observer, inject } from "mobx-react";
import { toast } from "react-toastify";

@inject("store")
@observer
class ForgotPassword extends Component {
  @observable email = "";
  @observable errorMessage = "";

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  constructor() {
    super();
    makeObservable(this);
  }
  onChange = (val) => {
    this.currentPromptOption = val;
    console.log(this.currentPromptOption);
  };

  onChangeAny = (val, attr) => {
    this[attr] = val;
    this.errorMessage = "";
  };

  onSubmit = async (e) => {
    try {
      e.preventDefault();
      let data = await this.props.store.api
        .post("/password-reset", {
          email: this.email,
        })
        .then(({ data }) => {
          toast(data);
        })
        .then(() => {
          this.props.history.push(`/`);
        });
      //   this.props.store.loginWithDataTokenAndProfile(data);
      console.log(data);
    } catch (err) {
      console.log(err);
      console.log(err?.response?.data?.message);
      toast.error(err?.response?.data);
      if (err?.response?.data?.message) {
        this.errorMessage = err?.response?.data?.message;
      }
    }
  };

  render() {
    return (
      <>
        <Helmet>
          <title>{`Login - Nord AI`}</title>
        </Helmet>

        <div className="bg-grey-900">
          <div className="container mx-auto min-h-screen flex flex-col md:items-center md:justify-center">
            <div>
              <img
                className="ml-auto mr-auto w-64 h-48 object-cover"
                src={Logo}
                alt="logo"
              />
            </div>

            <div
              className={`min-w-full md:min-w-0 bg-white rounded-xl shadow-xl transform transition-all  transition shadow-md hover:shadow-2xl focus:shadow-2xl w-1/2`}
            >
              <div className="px-4 py-4 md:px-12 md:py-12">
                <Switch>
                  <Route path="/reset">
                    <Reset
                      landingPageUrl={this.props.store.landingPageUrl}
                      email={this.email}
                      password={this.password}
                      signUp={this.signUpWithGoogle}
                      onChange={this.onChangeAny}
                      onSubmit={this.onSubmit}
                    />
                  </Route>

                  <Route>
                    <Redirect to="/reset" />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const Reset = observer(
  ({ active, email, password, onChange, onSubmit, landingPageUrl, signUp }) => {
    return (
      <>
        <form onSubmit={onSubmit}>
          <div
            className={`mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-${
              email ? "green" : "gray"
            }-300  ${email ? "bg-green-300" : "bg-gray-300"} `}
          >
            <LockClosedIcon
              className={`h-8 w-8 ${
                active ? "text-green-700" : "text-gray-500"
              } text-${email ? "green-700" : "gray-500"}`}
              aria-hidden="true"
            />
          </div>
          <div className="mt-3 text-center ">
            <div className="text-3xl font-medium text-gray-900">
              Glemt kodeord?
            </div>
            <p className="text-lg text-gray-500">Indtast din e-mailadresse</p>
            <div className="flex flex-col flex-1">
              <label className="text-gray-400 text-sm block mt-4 inline-block text-left">
                Email
              </label>
              <input
                value={email}
                onChange={(e) => onChange(e.target.value, "email")}
                focus="true"
                type="email"
                className="rounded-md text-lg px-4 py-2  border border-gray-300 "
                placeholder="john@smith.com"
              />
            </div>

            <div className="flex flex-col">
              <button
                type="submit"
                className="hover:bg-gray-600 font-medium rounded-lg text-lg px-4 py-2 bg-gray-500 text-white mt-4 border border-gray-300 inline-block"
              >
                Send e-mail
              </button>
              {/* <div onClick={signUp} className="hover:bg-gray-600 font-medium rounded-lg text-lg px-4 py-2 bg-gray-500 text-white mt-4 border border-gray-300 inline-block" >
						signUp Google
						</div>
						 */}
              <Link to={`/login`} className="mt-4 text-gray-400 text-sm">
                Husket adgangskoden? Log ind her
              </Link>
            </div>
          </div>
        </form>
      </>
    );
  }
);

export default withRouter(ForgotPassword);
